import { useContext } from "react";
import { MainMenuContext } from "../context/index.js";
const useMainMenuContext = ()=>{
    const context = useContext(MainMenuContext);
    if (!context) throw new Error('useMainMenuContext must be used within a MainMenuProvider');
    return context;
};
const hooks_useMainMenuContext = useMainMenuContext;
export default hooks_useMainMenuContext;
